import { Component } from 'preact'
import Sentry from '../sentry.config'

class ErrorBoundary extends Component {
  state = { error: null }

  static getDerivedStateFromError(error: Error) {
    return { error: error.message }
  }

  componentDidCatch(error: Error) {
    console.error(error)
    this.setState({ error: error.message })
    Sentry.captureException(error)
  }

  render() {
    if (this.state.error) {
      return <p>Oh no! We ran into an error: {this.state.error}</p>
    }
    return this.props.children
  }
}

export default ErrorBoundary
